<template>
  <div class="UsLicenses-container">
    <div class="title-content">
      <img src="./../assets/image/licenses-icon.png" class="title-logo" @click="goHome" />
    </div>
    <div class="title-us">
      <div class="us-text">Privacy Notice</div>
    </div>
    <div class="state-content">
      <div class="state-title">Gramm–Leach–Bliley Act (GLBA) Privacy Notice</div>
      <div class="state-text-box">
        <div class="text-title">Effective Date: September 01, 2025</div>

        <div>
          This notice is provided to you in accordance with the federal Gramm–Leach–Bliley Act (“GLBA”). It describes how Alchemy Pay Inc. (“Company,” “we,” “our,” or “us”)
          collects, uses, and shares non-public personal information of consumers who use our financial services.
        </div>
        <div>Information We Collect</div>
        <div>We may collect the following types of non-public personal information when you apply for, access, or use our services:</div>
        <div class="pl8">- Identifying information (name, address, email, phone number, date of birth).</div>
        <div class="pl8">- Government identification numbers (driver’s license, passport, taxpayer ID).</div>
        <div class="pl8">- Financial account information (bank account details, payment card numbers, transaction history).</div>
        <div class="pl8">- Device and online identifiers (IP address, browser information, login data).</div>
        <div>How We Use Information</div>
        <div>We use this information to:</div>
        <div class="pl8">- Provide financial services, including ramp services.</div>
        <div class="pl8">- Verify identity and comply with anti-money-laundering (AML) and other legal obligations.</div>
        <div class="pl8">- Process and record transactions.</div>
        <div class="pl8">- Maintain accounts and provide customer support.</div>
        <div class="pl8">- Protect against fraud, unauthorized transactions, and misuse of services.</div>
        <div>How We Share Information</div>
        <div>We do not sell your personal information. We may share information only as permitted by law, including with:</div>
        <div class="pl8">- Service providers and vendors.</div>
        <div class="pl8">- Regulatory authorities and law enforcement.</div>
        <div class="pl8">- Affiliates for compliance, risk management, and operational support.</div>
        <div class="pl8">- Authorized delegates/agents.</div>
        <div>Your Rights</div>
        <div>Federal law gives you the right to limit some, but not all, sharing of your personal information.</div>
        <div>You may opt out of our sharing with non-affiliates for marketing purposes.</div>
        <div>To exercise your rights, contact us at: [Insert compliance email/address].</div>
        <div>Safeguarding Your Information</div>
        <div>We maintain physical, electronic, and procedural safeguards to protect your information, consistent with GLBA requirements.</div>
        <div>Questions?</div>
        <div>If you have questions about this notice, please contact us at:</div>
        <div>Email: compliance-us@alchemypay.org</div>
        <div>Address: Ste 101, 3120 Scott Blvd, Santa Clara CA 95054</div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {};
  },
  components: {
    Footer,
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
  mounted() {},
  destroyed() {},
  created() {},
};
</script>
<style lang="scss" scoped>
.pl8 {
  text-indent: 2em;
}
@media screen and (max-width: 1180px) {
  .title-content {
    height: 100px;
    padding: 31px 0 35px 20px;
    box-sizing: border-box;
    background: #fff;
  }
  .title-logo {
    width: 149px;
    height: 24px;
    object-fit: cover;
    cursor: pointer;
  }
  .title-us {
    width: 100%;
    height: 100px;
    color: #fff;
    text-align: center;
    background: #000;
  }
  .us-text {
    font-family: "Bold";
    font-size: 24px;
    line-height: normal;
    padding-top: 30px;
  }
  .list-box {
    margin: 36px auto 0 auto;
  }
  .list-title {
    font-family: "Bold";
    font-size: 20px;
    color: #000;
    margin-left: 16px;
    margin-right: 16px;
  }
  .item-list {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 20px 16px 0 16px;
  }
  .item-row {
    width: 100%;
    display: flex;
    align-items: center;
    font-family: "Medium";
    font-size: 11px;
    color: #525868;
    border-top: 1px solid var(--1, #ccd2e2);
  }
  .Iowa {
    border-bottom: 1px solid var(--1, #ccd2e2);
  }
  .item-row div:nth-child(1) {
    width: 33.33%;
    height: 48px;
    line-height: 48px;
    border-left: 1px solid var(--1, #ccd2e2);
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(2) {
    width: 33.33%;
    height: 48px;
    line-height: 48px;
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(3) {
    width: 33.33%;
    height: 48px;
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .state-content {
    margin: 36px 16px 0 16px;
    padding-bottom: 36px;
  }
  .state-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
    margin-bottom: 34px;
  }
  .state-text-box {
    font-size: 16px;
    color: #525868;
    font-family: "Medium";
    line-height: 40px;
  }
  .text-title {
    margin-bottom: 35px;
  }
  .bottom-text {
    margin-top: 34px;
  }
  .link-style {
    color: #0b48e6;
  }
  .link-style:hover {
    text-decoration: none;
    border-bottom: 1.5px solid blue;
  }
}
@media (min-width: 1180px) and (max-width: 10000px) {
  .title-content {
    height: 100px;
    padding: 31px 0 35px 77px;
    box-sizing: border-box;
    background: #fff;
  }
  .title-logo {
    width: 211px;
    height: 34px;
    object-fit: cover;
    cursor: pointer;
  }
  .title-us {
    width: 100%;
    height: 200px;
    color: #fff;
    text-align: center;
    background: #000;
  }
  .us-text {
    font-family: "Bold";
    font-size: 60px;
    line-height: normal;
    padding-top: 59px;
  }
  .list-box {
    width: 1180px;
    margin: 80px auto 0 auto;
  }
  .list-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
  }
  .item-list {
    border: 1px solid var(--1, #ccd2e2);
    border-bottom: none;
    margin-top: 40px;
  }
  .item-row {
    display: flex;
    align-items: center;
    font-family: "Medium";
    font-size: 16px;
    color: #525868;
  }
  .item-row div:nth-child(1),
  .item-row div:nth-child(2) {
    width: 260px;
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid var(--1, #ccd2e2);
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(2) {
  }
  .item-row div:nth-child(3) {
    // width: 393px;
    flex: 1;
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .state-content {
    width: 1180px;
    margin: 60px auto 0 auto;
    padding-bottom: 80px;
  }
  .state-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
    margin-bottom: 34px;
  }
  .state-text-box {
    font-size: 16px;
    color: #525868;
    font-family: "Medium";
    line-height: 40px;
  }
  .text-title {
    margin-bottom: 35px;
  }
  .bottom-text {
    margin-top: 34px;
  }
  .link-style {
    color: #0b48e6;
  }
  .link-style:hover {
    text-decoration: none;
    border-bottom: 1.5px solid blue;
  }
}
</style>
